import React from 'react';
import { ClipboardCheckIcon, BookOpenIcon, ShieldCheckIcon, WifiIcon, KeyRoundIcon, SmartphoneIcon, ShieldIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function IntroAssessmentPage() {
  return <div className="w-full min-h-screen bg-white flex flex-col" data-id="element-2400">
      {/* Header with logo */}
      <header className="w-full bg-white border-b border-gray-100 px-5 py-3" data-id="element-2401">
        <div className="max-w-md mx-auto flex items-center justify-center" data-id="element-2402">
          <Link to="/" className="flex-shrink-0" data-id="element-2403">
            <img src="https://cdn.magicpatterns.com/uploads/8EVxVy8dkAVEdmFcPkswyr/Caveo_2026_Logo.png" alt="Caveo" className="h-6" data-id="element-2404" />
          </Link>
        </div>
      </header>

      {/* Main content */}
      <div className="px-5 pt-4 pb-6 flex-1 flex flex-col" data-id="element-2405">
        <div className="max-w-md mx-auto flex flex-col items-center text-center flex-1" data-id="element-2406">
          {/* Heading */}
          <h1 className="text-[1.75rem] md:text-[2.25rem] font-semibold text-[#111111] leading-[1.15] tracking-tight mb-1" data-id="element-2407">
            Digital Safety Check
          </h1>
          <p className="text-sm md:text-base text-gray-500 leading-relaxed mb-4" data-id="element-2408">
            Get a personalized action plan in 3-4 minutes.
          </p>

          {/* Three-step process */}
          <div className="flex items-center justify-center mb-5" data-id="element-2409">
            <div className="flex flex-col items-center" data-id="element-2410">
              <div className="w-10 h-10 rounded-full border-2 border-gray-200 flex items-center justify-center bg-white" data-id="element-2411">
                <ClipboardCheckIcon size={18} className="text-gray-400" data-id="element-2412" />
              </div>
              <span className="mt-1.5 text-xs font-semibold text-[#111111]" data-id="element-2413">
                Assess
              </span>
            </div>

            <div className="w-8 md:w-12 h-[2px] bg-gray-200 mb-4" data-id="element-2414" />

            <div className="flex flex-col items-center" data-id="element-2415">
              <div className="w-10 h-10 rounded-full border-2 border-gray-200 flex items-center justify-center bg-white" data-id="element-2416">
                <BookOpenIcon size={18} className="text-gray-400" data-id="element-2417" />
              </div>
              <span className="mt-1.5 text-xs font-semibold text-[#111111]" data-id="element-2418">
                Plan
              </span>
            </div>

            <div className="w-8 md:w-12 h-[2px] bg-gray-200 mb-4" data-id="element-2419" />

            <div className="flex flex-col items-center" data-id="element-2420">
              <div className="w-10 h-10 rounded-full border-2 border-gray-200 flex items-center justify-center bg-white" data-id="element-2421">
                <ShieldCheckIcon size={18} className="text-gray-400" data-id="element-2422" />
              </div>
              <span className="mt-1.5 text-xs font-semibold text-[#111111]" data-id="element-2423">
                Act
              </span>
            </div>
          </div>

          {/* What we'll cover label */}
          <p className="text-[#631bb7] text-sm mb-3 font-medium" data-id="element-2424">
            Here's what we'll cover:
          </p>

          {/* What's Covered */}
          <div className="flex flex-wrap justify-center gap-2 mb-6" data-id="element-2425">
            <div className="flex px-3 py-2 bg-white rounded-lg border border-gray-200 shadow-sm items-center justify-center" data-id="element-2426">
              <span className="text-lg flex-shrink-0" data-id="element-2427">🏠</span>
              <span className="ml-1.5 text-xs text-[#111111] whitespace-nowrap font-medium" data-id="element-2428">
                Home Network
              </span>
            </div>
            <div className="flex items-center px-3 py-2 bg-white rounded-lg border border-gray-200 shadow-sm" data-id="element-2429">
              <span className="text-lg flex-shrink-0" data-id="element-2430">🔐</span>
              <span className="ml-1.5 text-xs text-[#111111] whitespace-nowrap font-medium" data-id="element-2431">
                Passwords
              </span>
            </div>
            <div className="flex items-center px-3 py-2 bg-white rounded-lg border border-gray-200 shadow-sm" data-id="element-2432">
              <span className="text-lg flex-shrink-0" data-id="element-2433">📱</span>
              <span className="ml-1.5 text-[#111111] whitespace-nowrap text-xs font-medium" data-id="element-2434">
                Devices
              </span>
            </div>
            <div className="flex items-center px-3 py-2 bg-white rounded-lg border border-gray-200 shadow-sm" data-id="element-2435">
              <span className="text-lg flex-shrink-0" data-id="element-2436">🛡️</span>
              <span className="ml-1.5 text-xs text-[#111111] whitespace-nowrap font-medium" data-id="element-2437">
                Data & Privacy
              </span>
            </div>
          </div>

          <div className="mt-auto w-full pt-4" data-id="element-2438">
            {/* Start Assessment button */}
            <Link to="/assessment" className="block w-full bg-[#631bb7] text-white px-6 py-3.5 rounded-xl font-medium text-base no-underline hover:bg-[#521099] transition-all shadow-md" data-id="element-2439">
              Start Assessment
            </Link>
          </div>
        </div>
      </div>
    </div>;
}